export default __webpack_public_path__ + "static/media/ToyCar.f4633500.jpg";